import React from 'react';

import getImageUrl from '../../modules/getImageUrl';
import { Cyclingnews } from '../../modules/sites/definitions/Cyclingnews';
import { DigitalCameraWorld } from '../../modules/sites/definitions/DigitalCameraWorld';
import { GuitarPlayer } from '../../modules/sites/definitions/GuitarPlayer';
import { GuitarWorld } from '../../modules/sites/definitions/GuitarWorld';
import { LouderSound } from '../../modules/sites/definitions/LouderSound';
import { MusicRadar } from '../../modules/sites/definitions/MusicRadar';
import { TechRadar } from '../../modules/sites/definitions/TechRadar';
import { TechRadarPro } from '../../modules/sites/definitions/TechRadarPro';
import { TomsGuide } from '../../modules/sites/definitions/TomsGuide';
import { WhatHiFi } from '../../modules/sites/definitions/WhatHiFi';
import { Site } from '../../modules/sites/Site';
import { Translate } from '../../types/Localiser';
import LazyImage from '../GenericComponents/LazyLoad/LazyImage';

import styles from './styles/tabletop-header.css';

type Props = {
  site: Site;
  translate: Translate;
};

const renderLogo = (site: Site): JSX.Element | null => {
  switch (site) {
    case TechRadar:
      return (
        <LazyImage
          src={getImageUrl('sites-white/techradarWhite.svg')}
          alt={site.label}
          className="tabletop-techradar-logo"
        />
      );
    case TechRadarPro:
      return (
        <LazyImage
          src={getImageUrl('sites-white/techradarproWhite.svg')}
          alt={site.label}
          className="tabletop-techradarpro-logo"
        />
      );
    case TomsGuide:
      return (
        <LazyImage
          src={getImageUrl('sites-white/tomsguideWhite.svg')}
          alt={site.label}
          className="tabletop-tomsguide-logo"
        />
      );
    case WhatHiFi:
      return (
        <LazyImage
          src={getImageUrl(`sites/${site.logo}`)}
          alt={site.label}
          className="tabletop-universal-logo"
        />
      );
    case Cyclingnews:
      return (
        <LazyImage
          src={getImageUrl('sites-white/cyclingnewsWhite.svg')}
          alt={site.label}
          className="tabletop-universal-logo"
        />
      );
    case MusicRadar:
      return (
        <LazyImage
          src={getImageUrl('sites-white/musicradarWhite.svg')}
          alt={site.label}
          className="tabletop-universal-logo"
        />
      );
    case GuitarWorld:
      return (
        <LazyImage
          src={getImageUrl('sites-white/guitarworldWhite.svg')}
          alt={site.label}
          className="tabletop-universal-logo"
        />
      );
    case GuitarPlayer:
      return (
        <LazyImage
          src={getImageUrl('sites-white/guitarplayerWhite.svg')}
          alt={site.label}
          className="tabletop-guitarplayer-logo"
        />
      );
    case LouderSound:
      return (
        <LazyImage
          src={getImageUrl('sites-white/loudersoundWhite.svg')}
          alt={site.label}
          className="tabletop-universal-logo"
        />
      );
    case DigitalCameraWorld:
      return (
        <LazyImage
          src={getImageUrl('sites-white/digitalcameraworldWhite.svg')}
          alt={site.label}
          className="tabletop-digitalcameraworld-logo"
        />
      );
    default:
      return null;
  }
};

export const TabletopHeader: React.FC<Props> = ({ site, translate }) => {
  const isSiteWithLogo = [
    TechRadar,
    TechRadarPro,
    TomsGuide,
    WhatHiFi,
    Cyclingnews,
    MusicRadar,
    GuitarWorld,
    GuitarPlayer,
    LouderSound,
    DigitalCameraWorld,
  ].includes(site);

  return (
    <div className={styles.header}>
      {!isSiteWithLogo && (
        <span className={styles.headerText}>{`${translate('bestSelection')} ${site.label}`}</span>
      )}
      {isSiteWithLogo && (
        <>
          <span className={styles.headerText}>{translate('bestSelection')}</span>
          {renderLogo(site)}
        </>
      )}
    </div>
  );
};
